import { useUserRates } from '../../hooks/useUsers.js';
import { centsToUsd, iso } from '../../lib/format.js';

// Vertical timeline of every rate row for a user, newest first.
// Includes both the current open row (effective_to == null) and every
// past row created by admin updates / backdated corrections.
export default function RateHistoryTimeline({ userId }) {
  const { data: rates = [], isLoading } = useUserRates(userId);

  if (isLoading) return <div className="loading">Loading history…</div>;
  if (!rates.length) return <div style={{ color: 'var(--warm-gray)', fontSize: 12 }}>No rate history yet.</div>;

  return (
    <div style={{ borderLeft: '2px solid var(--surface-container-high)', paddingLeft: 14, marginTop: 8 }}>
      {rates.map(r => {
        const open = r.effective_to == null;
        return (
          <div key={r.id} style={{ position: 'relative', marginBottom: 18 }}>
            <div style={{
              position: 'absolute', left: -22, top: 4, width: 10, height: 10,
              borderRadius: 0, background: open ? 'var(--orange)' : 'var(--warm-gray)',
              transform: 'rotate(45deg)',
            }} />
            <div style={{
              fontFamily: 'var(--font-headline)', fontSize: 18, fontWeight: 700,
              color: open ? 'var(--orange)' : 'var(--on-surface)', letterSpacing: '0.02rem',
            }}>
              {centsToUsd(r.hourly_rate_cents)}/hr
              {open && <span className="badge orange" style={{ marginLeft: 8 }}>current</span>}
            </div>
            <div style={{ fontSize: 11, color: 'var(--warm-gray)', textTransform: 'uppercase', letterSpacing: '0.06rem', marginTop: 2 }}>
              {iso(r.effective_from)} → {r.effective_to == null ? '∞' : iso(r.effective_to - 1)}
            </div>
            <div style={{ fontSize: 12, color: 'var(--on-surface-variant)', marginTop: 4 }}>
              OT after {r.ot_threshold_hrs}h at {r.ot_multiplier}×
              {r.set_by_name && <> · set by {r.set_by_name}</>}
            </div>
            {r.reason && (
              <div style={{ fontSize: 12, color: 'var(--on-surface-variant)', marginTop: 4, fontStyle: 'italic' }}>
                "{r.reason}"
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
